export async function fetchCsoData(): Promise<any> {
  const cso_list = 'cso_list';
  const apiUrl = `https://${process.env.NEXT_PUBLIC_API_ID}.execute-api.${process.env.NEXT_PUBLIC_REGION}.amazonaws.com/dev/${cso_list}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching CSO data: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch CSO data:', error);
    throw error;
  }
}
